import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana29Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
  <rect width="1221" height="921" fill="url(#pattern0_1468_40449)"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("1"))}
    d="M396.849 458.17L451.893 394.319L383.161 338.474C382.025 337.551 380.698 336.864 379.259 336.596C360.835 333.167 358.181 348.687 359.279 358.055C359.36 358.747 359.543 359.419 359.789 360.07L396.849 458.17Z" 
    fill={getFillByLot(1, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("8"))}
    d="M427.668 539.639L396.843 458.173L416.659 436.155L498.124 502.209L451.887 559.455L427.668 539.639Z" 
    fill={getFillByLot(8, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("2"))}
    d="M533.363 458.172L498.135 502.207L416.669 436.154L451.897 394.32L533.363 458.172Z" 
    fill={getFillByLot(2, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("3"))}
    d="M612.618 519.819L533.354 458.169L498.126 502.204L577.39 563.854L612.618 519.819Z" 
    fill={getFillByLot(3, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("4"))}
    d="M678.684 572.667L612.631 519.824L577.402 563.86L674.281 638.72L678.684 572.667Z" 
    fill={getFillByLot(4, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("5"))}
    d="M670.1 709.68L674.275 638.713L628.038 603.484L579.599 662.932L652.91 721.15C653.94 721.968 655.034 722.759 656.315 723.059C661.033 724.163 665.206 720.486 667.832 716.891C669.35 714.814 669.949 712.249 670.1 709.68Z" 
    fill={getFillByLot(5, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("6"))}
    d="M515.744 610.09L579.596 662.933L628.035 603.485L561.981 552.844L515.744 610.09Z" 
    fill={getFillByLot(6, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("7"))}
    d="M451.899 559.45L515.751 610.091L561.988 552.845L498.137 502.204L451.899 559.45Z" 
    fill={getFillByLot(7, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
  <defs>
    <pattern 
    id="pattern0_1468_40449" 
    patternContentUnits="objectBoundingBox" 
    width="1" 
    height="1">
    <use 
    href="#image0_1468_40449" 
    transform="matrix(0.0030201 0 0 0.00400385 -5.0036 -1.49005)"/>
    </pattern>
    <image 
      id="image0_1468_40449"
      width="4096" 
      height="2304" 
      href="/mz2.png"
    />
  </defs>
</svg>

  );
};